export const TITLE = 'Online Deposits';

export const ROW_LABELS = {
  PENDING: 'Pending',
  COLLECTED: 'Collected',
};

export const NOT_AVAILABLE = 'N/A';

export const ERROR_MESSAGES = {
  FETCH_PENDING_PAY_REQS_TOTAL_ERROR: 'Could not load pending deposits total at the moment.',
  FETCH_COLLECTED_PAY_REQS_TOTAL_ERROR: 'Could not load collected deposits total at the moment.',
  FETCH_ALL_PAY_REQS_TOTAL_ERROR: 'Could not load online deposits at the moment.',
};
